export const PRICE_PER_WORD = 0.00001;
export const WORDS_MIN = 100000;
export const WORDS_MAX = 10000000;
export const WORDS_STEP = 100000;
export const FREE_WORDS = 50000;
export const USER_ROLES = Object.freeze({
	USER: "USER",
	ADMIN: "ADMIN",
});

export const API_KEY_PRICING_ANCHORS = Object.freeze([
	Object.freeze({
		words: 100_000,
		multiplier: 2,
	}),
	Object.freeze({
		words: 500_000,
		multiplier: 1.8,
	}),
	Object.freeze({
		words: 1_000_000,
		multiplier: 1.5,
	}),
	Object.freeze({
		words: 2_500_000,
		multiplier: 1.25,
	}),
	Object.freeze({
		words: 5_000_000,
		multiplier: 1,
	}),
	Object.freeze({
		words: 7_500_000,
		multiplier: 0.95,
	}),
	Object.freeze({
		words: 10_000_000,
		multiplier: 0.85,
	}),
]);

/**
 * @param {number} value
 * @param {number} fromValue
 * @param {number} toValue
 * @param {number} fromMultiplier
 * @param {number} toMultiplier
 */
function interpolateLinear(value, fromValue, toValue, fromMultiplier, toMultiplier) {
	if (toValue <= fromValue) return fromMultiplier;
	const progress = (value - fromValue) / (toValue - fromValue);
	return fromMultiplier + (toMultiplier - fromMultiplier) * progress;
}

/**
 * @param {number} words
 */
export function getApiKeyPriceMultiplier(words) {
	const normalizedWords = Number(words);

	if (!Number.isFinite(normalizedWords) || normalizedWords <= 0) {
		return 1;
	}

	const anchors = API_KEY_PRICING_ANCHORS;

	if (normalizedWords <= anchors[0].words) {
		return anchors[0].multiplier;
	}

	for (let i = 0; i < anchors.length - 1; i++) {
		const from = anchors[i];
		const to = anchors[i + 1];

		if (normalizedWords <= to.words) {
			return interpolateLinear(
				normalizedWords,
				from.words,
				to.words,
				from.multiplier,
				to.multiplier,
			);
		}
	}

	return anchors[anchors.length - 1].multiplier;
}

/**
 * @param {number} value
 * @param {number} decimals
 */
export function roundPrice(value, decimals = 1) {
	const normalized = Number(value);
	if (!Number.isFinite(normalized)) return 0;

	const factor = Math.pow(10, decimals);
	return Math.round(normalized * factor) / factor;
}

/**
 * @param {number} words
 */
export function calculateApiKeyPrice(words) {
	const normalizedWords = Number(words);
	if (!Number.isFinite(normalizedWords) || normalizedWords <= 0) return 0;
	const multiplier = getApiKeyPriceMultiplier(normalizedWords);
	const rawPrice = normalizedWords * PRICE_PER_WORD * multiplier;
	return roundPrice(rawPrice);
}

/**
 * @param {number} words
 */
export function calculateApiKeyAmountCents(words) {
	return Math.round(calculateApiKeyPrice(words) * 100);
}
